import { useState } from "react";
import { createInvoice } from "../../api/invoiceService";

export const useCreateInvoice = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createInvoice(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create invoice:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};